/**
 * Helper functions for timezone conversions between UTC and local time
 */

/**
 * Convert UTC time string to local time for datetime-local input
 * @param utcDateString - UTC timestamp string (ISO format)
 * @returns Local time string formatted for datetime-local input (YYYY-MM-DDTHH:mm)
 */
export const utcToLocal = (utcDateString: string): string => {
  if (!utcDateString) return '';
  const date = new Date(utcDateString);
  // Get local timezone offset in minutes
  const timezoneOffset = date.getTimezoneOffset();
  // Adjust for local timezone
  const localDate = new Date(date.getTime() - timezoneOffset * 60000);
  // Return in format required by datetime-local input (YYYY-MM-DDTHH:mm)
  return localDate.toISOString().slice(0, 16);
};

/**
 * Convert local time string back to UTC for storage
 * @param localDateString - Local time string from datetime-local input
 * @returns UTC timestamp string in ISO format
 */
export const localToUtc = (localDateString: string): string => {
  if (!localDateString) return '';
  const date = new Date(localDateString);
  // The datetime-local input gives us local time, convert to UTC
  return date.toISOString();
};
